import 'babel-polyfill'
import Vue from 'vue'
import vuetify from './plugins/vuetify';
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import App from './App.vue'
import VueMask from 'v-mask'

import { Ripple } from 'vuetify/lib/directives'

Vue.config.productionTip = false
Vue.use(VueAxios, axios);
Vue.use(router);
Vue.use(vuetify, {
  theme: {
    arla: {
      primary: "#91CCC8",
      secondary: "#e57373",
      accent: "#9c27b0",
      error: "#f44336",
      warning: "#ffeb3b",
      info: "#2196f3",
      success: "#4caf50"
    }
  },
  directives: {
    Ripple
  }
})
Vue.use(VueMask);
new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
